import { goTo } from '@itau-loans-www/utils'

const useLoanReason = () => {
  const onSubmit = ({ reason }) => {
    const value = reason ?? 'formalizar proposta'

    window.analytics.track(`Tela Objetivo - ${value}`, () => {
      console.log(`[ Segment ] - Tela Objetivo - ${value} `)
    })

    goTo('final-screen-online-formalization-summary-success')
  }

  const reasonOptions = [
    {
      id: 'quitar-dividas',
      label: `<strong>quitar dívidas</strong>`,
      value: `quitar dividas`
    },
    {
      id: 'despesas',
      label: `<strong>despesas da casa</strong>`,
      value: `despesas da casa`
    },
    {
      id: 'investir',
      label: `<strong>investir</strong>`,
      value: `investir`
    },
    {
      id: 'viajar',
      label: `<strong>viajar</strong>`,
      value: `viajar`
    },
    {
      id: 'saúde',
      label: `<strong>saúde</strong>`,
      value: `saude`
    },
    {
      id: 'compras',
      label: `<strong>compras</strong>`,
      value: `compras`
    },
    {
      id: 'estudos',
      label: `<strong>estudos</strong>`,
      value: `estudos`
    },
    {
      id: 'outros',
      label: `<strong>outros</strong>`,
      value: `outros`
    }
  ]

  return {
    onSubmit,
    reasonOptions
  }
}

export default useLoanReason
